import {BaseEntity} from '../../common/base-entity';

export type CirfFieldStatusType = 'MANDATORY' | 'OPTIONAL' | 'HIDDEN';

export const CirfFieldStatusValue = {
    mandatory : <CirfFieldStatusType>'MANDATORY',
    optional : <CirfFieldStatusType>'OPTIONAL',
    hidden : <CirfFieldStatusType>'HIDDEN'
}

export class CirfField extends BaseEntity {
    fieldLabel: string;
    fieldKey: string;
    fieldStatus: CirfFieldStatusType;
    parentKey: string;
    isUdf: boolean;
    isStatusReadOnly: boolean;
    isVisibilityReadOnly: boolean;
    index: number;
}
